import api from '@/core/apiclient'
import {actionTypes, mutationTypes} from '@/core/constants'

export default {

    async [actionTypes.REAVALIACAO.CADASTRAR_REAVALIACAO]({commit}, dados) {
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        const {data} = await api.reavaliacao.cadastrar(dados)
        commit(mutationTypes.MOVIMENTACAO.SET_MOVIMENTACAO, data)
        commit(mutationTypes.LOKI.DISABLE_GLOBAL_LOADING)
        return data
    },

    async [actionTypes.REAVALIACAO.BUSCAR_REAVALIACAO_POR_PATRIMONIO](context, dados) {
        const {data} = await api.reavaliacao.buscarReavaliacaoPorPatrimonio(dados)
        return data
    },

    async [actionTypes.REAVALIACAO.BUSCAR_REAVALIACAO_POR_ID](context, reavaliacaoId) {
        const {data} = await api.reavaliacao.buscarReavaliacaoPorId(reavaliacaoId)
        return data
    },

    async [actionTypes.REAVALIACAO.EDITAR_REAVALIACAO](context, dados) {
        const {data} = await api.reavaliacao.editarReavaliacao(dados)
        return data
    },

    async [actionTypes.REAVALIACAO.BUSCAR_REAVALIACOES]({state}) {
        const {filtros, paginacao} = state.todasReavaliacoes
        const {data} = await api.reavaliacao.buscarReavaliacoes(filtros, paginacao)
        return data
    },

}
